if (!customElements.get('glamojo-pills-scroll')) {
  customElements.define('glamojo-pills-scroll', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.gsp-subnav-pills');
      this.buttons = [...this.querySelectorAll('[data-direction]')];
      if (!this.track) return;

      this.update = () => {
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = this.track.scrollLeft;

        this.buttons.forEach((button) => {
          button.hidden = max <= 1;
          button.disabled = button.dataset.direction === '-1'
            ? position <= 1
            : position >= max - 1;
        });
      };

      this.handleClick = (event) => {
        const button = event.target.closest('[data-direction]');
        if (!button || !this.contains(button)) return;

        this.track.scrollBy({
          left: Number(button.dataset.direction) * this.track.clientWidth * 0.8,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'instant'
            : 'smooth'
        });
      };

      this.addEventListener('click', this.handleClick);
      this.track.addEventListener('scroll', this.update, { passive: true });

      this.observer = new ResizeObserver(this.update);
      this.observer.observe(this.track);
      [...this.track.children].forEach((item) => this.observer.observe(item));
      this.update();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.track?.removeEventListener('scroll', this.update);
      this.observer?.disconnect();
    }
  });
}